import React, { useEffect, useState } from 'react';
import './huntGraph.scss'
import Carousel from './slider';
import GridComponent from './grid';

const HuntGraph = (props) => {
  const [lineData, setLineData] = useState()
  const [barData, setBarData] = useState()

  useEffect(() => {
    let lines = props.harvestData.filter((item) => {
      if (item.graphType == "line") {
        return item
      }
    })

    let bars = props.harvestData.filter((item) => {
      if (item.graphType == "bar" && item.data) {
        // if (item.graphType == "bar") {
        return item
      }

    })

    setLineData(lines)
    setBarData(bars)
  }, [props.harvestData])

  return (
    <div>
      {lineData?.length > 0 && <div className='line-graph-grid-container'>
        {/* <Carousel GraphData={lineData} header={'Line Graph'}></Carousel> */}
        <GridComponent GraphData={lineData} header={'Line Graph'}></GridComponent>
      </div>}

      {barData?.length > 0 && <div className='Bar-graph-grid-container'>
        <h2 className='harvest-header'>Harvest Data</h2>
        {/* <Carousel GraphData={barData} header='Bar Graph'></Carousel> */}
        <GridComponent GraphData={barData} header='Bar Graph'></GridComponent>

      </div>}

    </div>
  )
}

export default HuntGraph
